var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.color ? _c('div', {
    staticClass: "node-area-back",
    class: `${_vm.color} lighten-5`
  }) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }